import React, { useState, useEffect, use } from "react";
import { Button, Form, Input, Select, message, Upload } from "antd";
import ImgCrop from "antd-img-crop";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import WangEditor from "./wangEditor";
import axios from "axios";
import localhost from "../../constants/localhost";

const CreateBox = ({ mode, detail }) => {
  const [fileList, setFileList] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    form.setFieldsValue(detail);
  }, []);

  const onSave = () => {
    const formData = form.getFieldsValue();
    axios
      .post(`${localhost}/manage/work/save`, formData)
      .then((res) => {
        message.success("新增成功");
        form.resetFields();
        navigate("/creation/smartAuditing");
      })
      .catch((error) => {
        message.error("网络异常，请重试！");
      });

    // form
    //   .validateFields((vals) => {
    //     const formData = vals;
    //     axios
    //       .post(`${localhost}/manage/work/save`, formData)
    //       .then((res) => {
    //         message.success("新增成功");
    //         form.resetFields();
    //         navigate("/creation/smartAuditing");
    //       })
    //       .catch((error) => {
    //         message.error("网络异常，请重试！");
    //       });
    //   })
    //   .catch((err) => {
    //     console.error("保存失败", err);
    //   });
  };

  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };
  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  return (
    <div style={{ height: "100%", overflow: "scroll" }}>
      {["detail", "edit"].includes(mode) && <h1>素材创作</h1>}
      <Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} form={form}>
        <Form.Item label="标题" name="title" required>
          <Input allowClear disabled={mode === "detail"} />
        </Form.Item>
        <Form.Item label="内容场景" name="contentType" required>
          <Select
            placeholder="请选择内容场景"
            allowClear
            disabled={mode === "detail"}
          >
            <Select.Option value="旅行者分享">旅行者分享</Select.Option>
            <Select.Option value="使用攻略">使用攻略</Select.Option>
            <Select.Option value="活动分享">活动分享</Select.Option>
            <Select.Option value="爱车养车">爱车养车</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="附件" name="file">
          <ImgCrop rotationSlider>
            <Upload
              // action="/upload.do"
              listType="picture-card"
              disabled={mode === "detail"}
              fileList={fileList}
              onChange={onChange}
              onPreview={onPreview}
            >
              <button
                style={{
                  color: "inherit",
                  cursor: "inherit",
                  border: 0,
                  background: "none",
                }}
                type="button"
              >
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>选择文件</div>
              </button>
            </Upload>
          </ImgCrop>
        </Form.Item>
        <Form.Item label="内容" name="content" required>
          <WangEditor disabled={mode === "detail"} />
        </Form.Item>
      </Form>
      {mode !== "detail" && (
        <div
          style={{ display: "flex", justifyContent: "center", marginTop: 16 }}
        >
          <Button type="primary" onClick={onSave} style={{ marginRight: 16 }}>
            保存并新增
          </Button>
          <Button onClick={onSave}>存为草稿</Button>
        </div>
      )}
    </div>
  );
};

export default CreateBox;
